import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  news: any = {}

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private util: UtilService
   ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    await this.GetNewsById(id)
    this.util.ShowWaiting(false)
  }

  async GetNewsById(id: string){
    let newsList: any = await this.apiService.get("crmservice", "news")
    let matchNews = newsList.filter((n: any) => {
      return n.dpa_newandactivityid.toString() === id
    })

    if(matchNews.length > 0){
      this.news = matchNews[0]
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/news/news.component.ts